import React from 'react';
import PropTypes from 'prop-types';
import useGetWidthByElement from 'hooks/useGetWidthByElement';

const propTypes = {
  children: PropTypes.node,
};

const BarBottomActions = ({ children }) => {
  //! State
  const width = useGetWidthByElement('main');

  //! Function

  //! Render
  return (
    <div className='bar-actions' style={{ width }}>
      {children}
    </div>
  );
};

BarBottomActions.propTypes = propTypes;
export default React.memo(BarBottomActions);
